import {
  GetApPayeeInfoResponse,
  GetApPayeeInfoResponseInvoiceReceiveEmailProcessType,
} from 'ap-openapi';
import { InvoiceReceiveEmailProcessType } from '../types';

/**
 * Maps API InvoiceReceiveEmailProcessType to domain type
 */
const mapApiProcessTypeToDomain = (
  apiType?: GetApPayeeInfoResponseInvoiceReceiveEmailProcessType
): InvoiceReceiveEmailProcessType | undefined => {
  if (!apiType) return undefined;
  switch (apiType) {
    case GetApPayeeInfoResponseInvoiceReceiveEmailProcessType.payment_request:
      return InvoiceReceiveEmailProcessType.PAYMENT_REQUEST;
    case GetApPayeeInfoResponseInvoiceReceiveEmailProcessType.received_invoice:
      return InvoiceReceiveEmailProcessType.RECEIVED_INVOICE;
    default:
      return undefined;
  }
};

export const GetMasterData = (data: GetApPayeeInfoResponse) => {
  return {
    generalInformation: GetGeneralInformationData(data),
    PICAndContractDetail: GetPICAndContractDetailData(data),
    receivingMethod: getReceivingMethodData(data),
    paymentRule: GetPaymentRuleData(data),
    transactionDefaultValue: GetTransactionDefaultValueData(data),
  };
};

const GetGeneralInformationData = (data: GetApPayeeInfoResponse) => {
  return {
    id: data?.id,
    display_name: data?.display_name,
  };
};

const getWebReceivingMethodData = (data: GetApPayeeInfoResponse) => {
  return {
    supplierUploadSetting: data?.supplier_upload_setting ?? undefined,
    is_supplier_upload_setting_enabled:
      data?.is_supplier_upload_setting_enabled,
    is_payee_active: data?.is_active,
  };
};

const getProxyReceiptReceivingMethodData = (data: GetApPayeeInfoResponse) => {
  return {
    is_proxy_receipt_receiving_method_enabled:
      data.is_agent_receive_setting_enabled,
    agentReceiveSetting: data.agent_receive_setting,
  };
};

const getEmailReceivingMethodData = (data: GetApPayeeInfoResponse) => {
  return {
    is_invoice_receive_email_setting_existed:
      data.is_invoice_receive_email_setting_existed,
    invoice_receive_email_address:
      data.invoice_receive_email_address ?? undefined,
    invoice_receive_email_process_type: mapApiProcessTypeToDomain(
      data.invoice_receive_email_process_type
    ),
    contact_office_member: data.contact_office_member,
    is_invoice_receive_mail_address_issued:
      data.is_invoice_receive_mail_address_issued,
  };
};

const getReceivingMethodData = (data: GetApPayeeInfoResponse) => {
  return {
    id: data?.id,
    webReceivingMethod: getWebReceivingMethodData(data),
    proxyReceivingMethod: getProxyReceiptReceivingMethodData(data),
    emailReceivingMethod: getEmailReceivingMethodData(data),
  };
};

const GetPICAndContractDetailData = (data: GetApPayeeInfoResponse) => {
  return {
    id: data?.id,
    ap_payee_contact_setting: data?.ap_payee_contact_setting,
    contact_office_members: data?.contact_office_members,
    contact_person_email: data?.contact_person_email,
    contact_person_full_address: data?.contact_person_full_address,
    contact_person_name: data?.contact_person_name,
    contact_person_phone_number: data?.contact_person_phone_number,
    dept_name: data?.dept_name,
  };
};

const GetPaymentRuleData = (data: GetApPayeeInfoResponse) => {
  return {
    payment_closing_date: data?.payment_closing_date,
    payment_month: data?.payment_month,
    payment_due_date: data?.payment_due_date,
    payment_holiday_rule: data?.payment_holiday_rule,
  };
};

const GetTransactionDefaultValueData = (data: GetApPayeeInfoResponse) => {
  return data?.ap_invoice_transaction_default_value;
};

const GetNullDataMaster = () => {
  return {
    generalInformation: { id: '', display_name: '' },
    PICAndContractDetail: {
      id: '',
      ap_payee_contact_setting: undefined,
      contact_office_members: undefined,
      contact_person_email: undefined,
      contact_person_full_address: undefined,
      contact_person_name: undefined,
      contact_person_phone_number: undefined,
      dept_name: undefined,
    },
    receivingMethod: {
      id: '',
      webReceivingMethod: {
        supplierUploadSetting: undefined,
        is_supplier_upload_setting_enabled: undefined,
        is_payee_active: undefined,
      },
      proxyReceivingMethod: {
        is_proxy_receipt_receiving_method_enabled: undefined,
        agentReceiveSetting: undefined,
      },
      emailReceivingMethod: {
        is_invoice_receive_email_setting_existed: undefined,
        invoice_receive_email_address: undefined,
        invoice_receive_email_process_type: undefined,
        contact_office_member: undefined,
        is_invoice_receive_mail_address_issued: undefined,
      },
    },
    paymentRule: {
      payment_closing_date: undefined,
      payment_month: undefined,
      payment_due_date: undefined,
      payment_holiday_rule: undefined,
    },
    transactionDefaultValue: undefined,
  };
};
export {
  GetGeneralInformationData,
  GetNullDataMaster,
  GetPaymentRuleData,
  GetPICAndContractDetailData,
  GetTransactionDefaultValueData,
};
